import React from 'react';
import Icon from '../../../components/AppIcon';

const BenefitsSection = () => {
  const benefits = [
    {
      id: 1,
      icon: "Brain",
      title: "Intelligence Artificielle Avancée",
      description: "Notre IA analyse vos réponses, vos intérêts et vos compétences pour vous recommander les filières les plus adaptées à votre profil unique.",
      color: "blue"
    },
    {
      id: 2,
      icon: "MessageSquare",
      title: "Chat Personnalisé 24/7",
      description: "Posez toutes vos questions à notre assistant IA disponible à tout moment pour vous guider dans votre orientation académique.",
      color: "green"
    },
    {
      id: 3,
      icon: "ClipboardList",
      title: "Quiz Scientifiques",
      description: "Passez des tests d'aptitude validés par des experts en orientation pour découvrir vos forces et vos domaines d'excellence.",
      color: "purple"
    },
    {
      id: 4,
      icon: "Trophy",
      title: "Système de Gamification",
      description: "Gagnez des points, débloquez des badges et progressez dans votre exploration des filières de manière ludique et motivante.",
      color: "amber"
    },
    {
      id: 5,
      icon: "School",
      title: "Annuaire des Écoles",
      description: "Accédez à une base de données complète de plus de 200 établissements au Sénégal avec informations détaillées et critères d'admission.",
      color: "red"
    },
    {
      id: 6,
      icon: "BarChart3",
      title: "Suivi de Progression",
      description: "Visualisez votre parcours d\'orientation avec des tableaux de bord détaillés et des indicateurs de progression personnalisés.",
      color: "indigo"
    }
  ];

  const getColorClasses = (color) => {
    const colorMap = {
      blue: "bg-blue-100 text-blue-600",
      green: "bg-green-100 text-green-600",
      purple: "bg-purple-100 text-purple-600",
      amber: "bg-amber-100 text-amber-600",
      red: "bg-red-100 text-red-600",
      indigo: "bg-indigo-100 text-indigo-600"
    };
    return colorMap?.[color] || colorMap?.blue;
  };

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12 lg:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-50 rounded-full mb-4">
            <Icon name="Sparkles" size={20} color="var(--color-primary)" />
            <span className="text-sm md:text-base font-medium text-blue-700">
              Fonctionnalités Clés
            </span>
          </div>

          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Tout ce dont vous avez besoin pour réussir
          </h2>

          <p className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto">
            CURSUS Orientation combine technologie de pointe et expertise pédagogique pour vous offrir une expérience d'orientation complète et personnalisée.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {benefits?.map((benefit) => (
            <div
              key={benefit?.id}
              className="group bg-white rounded-2xl p-6 md:p-8 border border-gray-200 hover:border-blue-300 hover:shadow-xl transition-all duration-300"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 rounded-xl ${getColorClasses(benefit?.color)} flex items-center justify-center mb-4 md:mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <Icon name={benefit?.icon} size={24} />
              </div>

              <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3">
                {benefit?.title}
              </h3>

              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                {benefit?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;